<template>
  <Modal id="ask-school" #default="{ close }">
    <h2>{{ $t('ModalAskSchool.title') }}</h2>
    <textarea class="bg" rows="4" :placeholder="$t('ModalAskSchool.textareaPlaceholder')" v-model="message"></textarea>
    <div class="actions">
      <button @click="send" class="primary">{{ $t('send') }}</button>
      <button @click="close">{{ $t('cancel') }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'ModalAskSchool',
  components: { Modal },
  data: () => ({
    message: '',
  }),
  methods: {
    send() {
      this.sendSupport({
        data: {
          type: 'request',
          message: this.message,
        },
      }).then(() => {
        this.message = ''
        this.openModal('ask-sent')
      })
    },
    ...mapMutations(['openModal']),
    ...mapActions('support', ['sendSupport']),
  },
}
</script>

<style lang="scss">
#modal-ask-school {
  h2 {
    margin-bottom: 18px;
  }

  textarea {
    margin-bottom: 15px;
  }
}
</style>
